import styled from 'styled-components';
import { Select } from '@leasequery/lq.react-component-library';

const PageSizeSelect = styled(Select)`
  width: auto;

  button {
    min-width: 8rem;
    max-width: 8rem;
  }
`;

export { PageSizeSelect };
